import {toast} from 'react-toastify';
import useGetCardNumber from '../../../services/hookService/getCardNumber/useGetCardNumber';

type AcceptedBankTypes = 'ملی' | 'پارسیان';

interface Props {
  bankName: AcceptedBankTypes;
}

const CardToCard = ({bankName}: Props) => {
  const {data, cadNumberIsLoading} = useGetCardNumber(bankName);

  const copyCode = (cardNumber: string) => {
    navigator.clipboard.writeText(cardNumber);
    toast.success('متن کپی شد!');
  };

  function formatCardNumber(cardNumber: string) {
    return (
      cardNumber
        .replace(/\s/g, '')
        .match(/.{1,4}/g)
        ?.join(' ') || ''
    );
  }

  if (cadNumberIsLoading) {
    return (
      <div className="w-full p-3 rounded-lg bg-[#F3ECE7] shadow-md flex flex-col gap-3 animate-pulse">
        <div className="flex items-center gap-2">
          <div className="w-12 h-12 rounded-full bg-gray-50" />

          <div className="w-24 h-4 rounded bg-gray-50" />
        </div>

        <div className="w-full h-10 rounded-full bg-gray-50" />

        <div className="w-40 h-4 rounded bg-gray-50" />
      </div>
    );
  }

  return (
    <>
      {data?.map(bank => (
        <div
          key={bank.card_number}
          className="w-full p-3 rounded-lg bg-[#F3ECE7] shadow-md flex flex-col gap-3"
        >
          <div className="flex items-center gap-2">
            <img
              src={bank?.bank_logo}
              alt="logo"
              className="w-12 h-12 mix-blend-multiply"
            />

            <span>{' بانک ' + bankName}</span>
          </div>

          <div
            className="flex justify-center gap-4 py-2 bg-white rounded-full"
            style={{direction: 'ltr'}}
            onClick={() => copyCode(bank.card_number)}
          >
            {formatCardNumber(bank.card_number)
              .split(' ')
              .map(chunk => (
                <span key={chunk}>{chunk}</span>
              ))}
          </div>

          <span className="text-sm">شرکت آینده پژوهان لوتوس</span>
        </div>
      ))}
    </>
  );
};

export default CardToCard;
